import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { isOkPseudoError } from '../feedbackResolution'

/** Aktif sonucu yeniden açar (kayıt silinmez, geçmiş kalır); bulunamayan / zaten açık kayıt 1404 döner. */
export class ReopenResolutionApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, resolutionId: number) {
    super({
      url: `admin/chatbot-analytics/resolutions/${encodeURIComponent(String(resolutionId))}/reopen`,
      requesterInfo,
    })
  }

  public async reopen(): Promise<void> {
    try {
      await this.postAsync<unknown>()
    } catch (error) {
      // Gövdesiz başarılı yanıt (Data = null, Message = "OK") ClientProxy'de hata olarak fırlar.
      if (isOkPseudoError(error)) return
      throw error
    }
  }
}
